import { Component, Input, OnChanges } from "@angular/core";
import { TranslationService } from "@services/translation.service";
import "./batteryIndicator.scss";

@Component({
    selector: 'battery-indicator',
    template: require('./batteryIndicator.component.html')
})
export class BatteryIndicatorComponent implements OnChanges {

    @Input() percentage: number;
    @Input() voltage: number;
    @Input() size: string = "s24"

    alert: boolean;

    tooltip: string = "";
    background: string = "";
    height: string = "";

    constructor(private readonly translationService: TranslationService) { }

    ngOnChanges(): void {
        this.processBatteryLevel();
    }

    private processBatteryLevel(): void {

        if (!this.percentage && this.voltage) {
            this.calculatePercentageFromVoltage();
        }

        this.alert = false;

        if (this.percentage <= 33) {
            this.alert = true;
        }

        if (!this.voltage) {
            this.tooltip = this.translationService.t("batteryIndicator.batteryLevel", this.percentage);
        }

        this.setBackground(this.percentage);
        this.setHeight(this.percentage);
    }

    private calculatePercentageFromVoltage(): void {
        // Based on 14v battery
        this.percentage = 0;

        if (this.voltage > 12) {
            this.percentage = 9;
        }
        if (this.voltage > 12.5) {
            this.percentage = 14;
        }
        if (this.voltage > 12.8) {
            this.percentage = 17;
        }
        if (this.voltage > 12.9) {
            this.percentage = 20;
        }
        if (this.voltage > 13.0) {
            this.percentage = 30;
        }
        if (this.voltage > 13.1) {
            this.percentage = 40;
        }
        if (this.voltage > 13.2) {
            this.percentage = 70;
        }
        if (this.voltage > 13.3) {
            this.percentage = 90;
        }
        if (this.voltage > 13.4) {
            this.percentage = 99;
        }
        if (this.voltage > 13.6) {
            this.percentage = 100;
        }

        this.tooltip = `${this.voltage}V`;
    }

    private setBackground(percentage: number): void {
        this.background = "red";

        if (this.percentage > 35) {
            this.background = "darkorange";
        }

        if (this.percentage > 75) {
            this.background = "green";
        }
    }

    private setHeight(percentage: number): void {
        this.height = `${percentage}%`;
    }

}
